import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueConfetti from 'vue-confetti'
import sanitizeHTML from 'sanitize-html'
import Firebase from "./firebase"


Firebase.init();

Vue.use(VueConfetti)

Vue.use(Buefy)


Vue.prototype.$sanitize = sanitizeHTML

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
